<fieldset class="parameters expected-move">
  <legend>
    <dx-check-box text="Expected Move Settings" [(value)]="this.enabled"></dx-check-box>
  </legend>
  <div class="expected-move-settings">
    <div class="body">
      <div class="parameter">
        <div class="label">Range Model</div>
        <div class="input">
          <dx-select-box [items]="this.rangeModelList" [(value)]="this.rangeModel" [disabled]="!this.enabled"
            (onValueChanged)="this.onChange()">
          </dx-select-box>
        </div>
      </div>
      
      <div class="parameter" *ngIf="this.rangeModel === 'Custom Percentage'">
        <div class="label">
          <dx-check-box text="Range 1" [(value)]="this.range1Enabled"
                        [disabled]="!this.enabled" (onValueChanged)="this.onChange()"></dx-check-box>
        </div>
        <div class="input">
          <dx-number-box [showSpinButtons]="true" [(value)]="this.rangeModelCustomPercent"
                         [disabled]="!this.enabled || !this.range1Enabled"
                         [showClearButton]="true"
                         [min]="0.01"
                         [max]="5"
                         [step]="0.01"
                         format="0#%"
          ></dx-number-box>
        </div>
      </div>

      <div class="parameter" *ngIf="this.rangeModel === 'Custom Percentage'">
        <div class="label">
          <dx-check-box text="Range 2" [(value)]="this.range2Enabled"
                        [disabled]="!this.enabled" (onValueChanged)="this.onChange()"></dx-check-box>
        </div>
        <div class="input">
          <dx-number-box [showSpinButtons]="true" [(value)]="this.range2CustomPercent"
                         [disabled]="!this.enabled || !this.range2Enabled"
                         [showClearButton]="true" [min]="0.01" [max]="5" [step]="0.01"
                         format="0#%"></dx-number-box>
        </div>
      </div>

      <div class="parameter">
        <div class="label">Show Days To Exp.</div>
        <div class="input">
          <dx-select-box [items]="this.daysToExpirationList"
                         [(value)]="this.daysToExpiration"
                         [disabled]="!this.enabled"
          ></dx-select-box>
        </div>
      </div>
      
      <div class="parameter">
        <div class="label">Where To Show</div>
        <div class="input">
          <dx-select-box [items]="this.whereToShowList"
                         [(value)]="this.whereToShow"
                         [disabled]="!this.enabled"
                         (onValueChanged)="this.onChange()"
          ></dx-select-box>
        </div>
      </div>
      
      <div class="parameter" *ngIf="this.showHmColumns">
        <div class="label">HM Columns To Show</div>
        <div class="input">
          <dx-select-box [items]="this.hmColumnsToShowList"
                         [(value)]="this.hmColumnsToShow"
                         [disabled]="!this.enabled"
          ></dx-select-box>
        </div>
      </div>
      <dx-check-box text="Show ATM Straddle $ Value" [(value)]="this.showAtmStraddleValue"
                    [disabled]="!this.enabled" (onValueChanged)="this.onChange()"></dx-check-box>
    </div>
  </div>
</fieldset>
